import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ActivityEntry from "src/components/Activity/ActivityEntry";
import DateSearch from "src/components/Activity/DateSearch";
import PaginationFooter from "src/components/Shared/PaginationFooter";
import MultiSelectObjectFilter from "src/components/Shared/Table/MultiRowSelect/MultiSelectObjectFilter";
import SortOrder from "src/components/Shared/Table/SortOrder";
import TRHeader from "src/components/Shared/Table/TRHeader";
import Table from "src/components/Shared/Table/Table";
import TableOptions from "src/components/Shared/TableOptions";
import useFetch from "src/hooks/useFetch";

const UserActivityList = ({ userDetails = null, me, ...props }) => {
  const activityTypes = [
    { key: "LOGIN", value: "Logins/Authentication" },
    { key: "USER_CREATE", value: "User Create" },
    { key: "USER_UPDATE", value: "User Update" },
    { key: "USER_PASSWORD_CHANGE", value: "User Password Change" },
    { key: "USER_SEND_RESET_PASSWORD_EMAIL", value: "User Send Reset Password Email" },
    { key: "USER_SEND_WELCOME_EMAIL", value: "User Send Welcome Email" },
    { key: "USER_STATUS_CHANGE_TO_ACTIVE", value: "User Status Change To Active" },
    { key: "USER_STATUS_CHANGE_TO_INACTIVE", value: "User Status Change To In-Active" },
    { key: "USER_DELETE", value: "User Delete" },
    // { key: "LAYOUT_UPDATE", value: "Layout Update" },
    // { key: "SMTP_UPDATE", value: "SMTP Update" },
    { key: "SETTINGS_UPDATE", value: "Settings Update" },
    { key: "EMAIL_TEMPLATE_UPDATE", value: "Email template Update" },
  ];
  const [sortDirection, setSortDirection] = useState("ASC");

  const [limit, setLimit] = useState(100);
  const [offset, setOffset] = useState(0);
  const [startDate, setStateDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Filters
  const [selectedActivityTypes, setSelectedActivityTypes] = useState([]);
  const [selectedPages] = useState([]);
  const [selectedIps, setSelectedIps] = useState([]);
  // const [deleteId, setDeleteId] = useState(null);

  const handleSelectedItems = (itemsArray, setSelected) => {
    let updatedSelected = itemsArray.reduce((filteredItemsArray, item) => (item.selected ? [...filteredItemsArray, item.key] : filteredItemsArray), []);
    setSelected(updatedSelected);
    setOffset(0);
  };

  const handlePaginationChange = ({ limit, offset }) => {
    setLimit(limit);
    setOffset(offset);
  };

  const {
    response: { data: ips },
  } = useFetch(`/activities/ip/list`);

  const {
    response: { data: activities, meta: activitiesMeta },
    status: { done: activitiesLoaded },
    refreshData: refreshActivities,
  } = useFetch(`/activities/list-activity`, {
    method: "PUT",
    query: {
      limit: limit,
      offset: offset * limit,
      start_date: startDate,
      end_date: endDate,
      sort_direction: sortDirection,
    },
    data: {
      users: [userDetails?._id],
      pages: selectedPages,
      activity_types: selectedActivityTypes,
      ip_address: selectedIps,
    },
  });

  useEffect(() => {
    refreshActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, offset, startDate, endDate, userDetails?._id, selectedActivityTypes, selectedPages, sortDirection, selectedIps]);

  // const exportData = async () => {
  //   const activityParams = {
  //     start_date: startDate,
  //     end_date: endDate,
  //     sort_direction: sortDirection,
  //   };
  //   const activityBody = {
  //     users: [userDetails?._id],
  //     pages: selectedPages,
  //     ip_address: selectedIps,
  //     activity_types: selectedActivityTypes,
  //   };
  //   try {
  //     const { data: responseData } = await apiRequest("put", "/activities/list-activity", { body: activityBody, queries: activityParams }, {}, true);
  //     let csvData = [];
  //     if (responseData.data.length > 0) {
  //       for (let index = 0; index < responseData.data.length; index++) {
  //         const element = responseData.data[index];
  //         let activity_types = element?.type;
  //         let typeIndex = activityTypes.findIndex((ty) => ty.key === element?.type);
  //         if (typeIndex !== -1) {
  //           activity_types = activityTypes[typeIndex].value;
  //         }
  //         csvData.push({
  //           Email: element?.user_id?.email,
  //           Name: element?.user_id?.name,
  //           "Activity Type": activity_types,
  //           Workspace: element?.data?.workspace_id?.name,
  //           "Page Accessed": element?.data?.page_id?.name,
  //           Date: formatDate(element?.created_at, "LLL"),
  //         });
  //       }
  //     }
  //     return csvData;
  //   } catch (error) {
  //     // console.dir("ERROR:", error);
  //   }
  // };

  return (
    <div className="animate-fade-in">
      <TableOptions
        leftContent={
          <DateSearch
            setStateDate={setStateDate}
            setEndDate={setEndDate}
            inline={true}
            placeholder={"Select dates"}
          />
        }
      />
      <Table
        tableHeader={
          <TRHeader>
            <th
              scope="col"
              className="rounded-tl-lg py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
              <div className="flex items-center gap-x-1">
                <p>Name</p>
              </div>
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              <div className="flex items-center gap-x-1">
                <p>Activity Type</p>
                <div className="flex">
                  <MultiSelectObjectFilter
                    xPlacement="bottomLeft"
                    filterSelect={true}
                    defaultOptions={activityTypes.map((type) => {
                      return { key: type.key, value: type.key, selected: selectedActivityTypes.includes(type.key), object: { _id: type.key, ...type } };
                    })}
                    onChange={(e) => {
                      handleSelectedItems(e, setSelectedActivityTypes);
                    }}
                  />
                </div>
              </div>
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              <div className="flex items-center gap-x-1">
                <p>Description</p>
              </div>
            </th>
            <th
              scope="col"
              className="table-cell rounded-tr-lg px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
              <div className="flex items-center gap-x-1">
                <p>Date</p>
                <SortOrder
                  sortDirection={sortDirection}
                  setSortDirection={(value) => {
                    setSortDirection(value);
                    setOffset(0);
                  }}
                />
              </div>
            </th>
            <th
              scope="col"
              className="rounded-tl-lg px-3 py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
              <div className="flex items-center gap-x-1">
                <p>Location/{me?.default_user && "IP Address"}</p>
                {me?.default_user && (
                  <div className="flex">
                    <MultiSelectObjectFilter
                      xPlacement="bottomRight"
                      filterSelect={true}
                      defaultOptions={ips?.map((ip) => {
                        return { key: ip._id, value: ip._id, selected: selectedIps.includes(ip._id), object: ip };
                      })}
                      searchableFields={["_id"]}
                      onChange={(e) => {
                        handleSelectedItems(e, setSelectedIps);
                      }}
                    />
                  </div>
                )}
              </div>
            </th>
          </TRHeader>
        }
        colSpan="5"
        loaded={activitiesLoaded}
        dataExists={activities.length > 0}>
        {activities.map((activity) => (
          <ActivityEntry
            key={activity._id}
            activity={activity}
            dataExists={activities.length > 0}
            activityTypes={activityTypes}
          />
        ))}
      </Table>

      <PaginationFooter
        itemName="Activity record"
        limit={limit}
        offset={offset}
        count={activitiesMeta.count}
        onChange={handlePaginationChange}
      />
      {/* {activities.length > 0 && (
        <DataExport
          title="Activity Report"
          headings={["Email", "Name", "Activity Type", "Workspace", "Page Accessed", "Date"]}
          prepData={exportData}
        />
      )} */}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    me: state.auth.user,
  };
};
export default connect(mapStateToProps, {})(UserActivityList);
